import { Building2, Briefcase, Landmark, Shield, Banknote, TrendingUp } from "lucide-react";

const lenders = [
  { icon: Building2, name: "Global Capital" },
  { icon: Briefcase, name: "Prime Lending" },
  { icon: Landmark, name: "Heritage Finance" },
  { icon: Shield, name: "Vanguard Cap" },
  { icon: Banknote, name: "Atlas Funding" },
  { icon: TrendingUp, name: "Summit Partners" },
];

const stats = [
  { value: "$500M+", label: "Funded to Date" },
  { value: "10,000+", label: "Businesses Helped" },
  { value: "24h", label: "Average Funding Time" },
  { value: "92%", label: "Approval Rate" },
];

export default function SocialProof() {
  return (
    <section data-testid="social-proof-section" className="relative py-20 md:py-28 border-y border-white/5 bg-[#070F1B]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-gold mb-4">
            Trusted Capital Partner
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-white tracking-tight max-w-3xl mx-auto">
            Direct in-house capital plus a vetted network of <span className="text-gold">top-tier lenders</span>.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 mb-16">
          {stats.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="bg-[#050B14] p-8 md:p-10 text-center hover:bg-[#0A1326] transition-colors"
            >
              <div className="font-heading text-4xl md:text-5xl font-light text-gold tracking-tighter">
                {s.value}
              </div>
              <div className="mt-2 text-xs md:text-sm tracking-wider uppercase text-white/60">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lender marquee */}
      <div className="overflow-hidden marquee-mask">
        <div className="flex gap-16 animate-marquee whitespace-nowrap" data-testid="lender-marquee">
          {[...lenders, ...lenders].map((l, i) => (
            <div key={i} className="flex items-center gap-3 text-white/40 hover:text-gold transition-colors">
              <l.icon className="w-6 h-6" />
              <span className="font-heading text-xl tracking-wide">{l.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
